const sectionTabsCss = `
[data-type='section-tabs'] .wrapper-container {
  --marquee-duration: 100s;
  padding: 40px 0;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header {
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 4px;
  border-radius: 10px;
  border: solid 1px;
  margin: 0 auto;
  margin-bottom: 30px !important;
  justify-content: center;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header[data-position='left'] {
  margin-left: 0;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header[data-position='center'] {
  margin: 0 auto;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header[data-position='right'] {
  margin-right: 0;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header .tab-header-item {
  color: var(--header-color, #8e1d08);
  padding: 4px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
}

[data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header .tab-header-item.active {
  color: #ffffff;
  background-color: var(--header-color, #8e1d08);
}

[data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item {
  display: none;
}

[data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h1,
[data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h2,
[data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h3 {
  font-size: 24px;
}

[data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item.active {
  display: block;
}

@container (max-width: 768px) {
  [data-type='section-tabs'] .wrapper-container {
    padding: 16px 0;
  }

  [data-type='section-tabs'] .wrapper-content .wrap-header-tab .list-tab-header {
    margin-bottom: 20px !important;
  }

  [data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h1,
  [data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h2,
  [data-type='section-tabs'] .wrapper-content .list-tab-content .tab-content-item h3 {
    font-size: 16px;
  }
}
`;
export default sectionTabsCss;
